import { initializeFaro, getWebInstrumentations } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

const collectorUrl = import.meta.env.VITE_APP_GRAFANA_FARO_URL || '';
const appName = import.meta.env.VITE_APP_GRAFANA_FARO_APP_NAME || 'hoa-portal';
const appVersion = import.meta.env.VITE_APP_GRAFANA_FARO_APP_VERSION || '1.0.0';

let faroInitialized = false;

export function initFaro() {
  if (!collectorUrl || faroInitialized || import.meta.env.DEV) return;

  initializeFaro({
    url: collectorUrl,
    app: {
      name: appName,
      version: appVersion,
      environment: import.meta.env.MODE
    },
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: true
      }),
      new TracingInstrumentation()
    ]
  });

  faroInitialized = true;
}
